import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { BACKEND_URL } from '../../../configs';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import {
  generateViolationProtocolPdfFailed,
  generateViolationProtocolPdfSuccessful,
} from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

const getFilenameFromResponse = response => {
  const header = response.headers.get('content-disposition');
  if (!header || !header.includes('filename=')) {
    return 'violation_protocol.pdf';
  }

  const matches = header.match(/filename\*=UTF-8''(.+)|filename="?(.+?)"?$/);
  return matches ? decodeURIComponent(matches[1] || matches[2]) : 'violation_protocol.pdf';
};

export default function* generateViolationProtocolPdf(action) {
  try {
    const { violationId, protocol = {} } = action.payload || {};
    if (!violationId) {
      throw new Error('Violation ID not found');
    }

    const url = `${BACKEND_URL}/violations/${violationId}/protocol/pdf`;
    const response = yield makeRequest(url, protocol, action, 'POST', true);

    if (response.status === OK) {
      const data = yield response.blob();
      data.filename = getFilenameFromResponse(response);
      yield put(generateViolationProtocolPdfSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response, {});
      yield put(generateViolationProtocolPdfFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(generateViolationProtocolPdfFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
